exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".header__2j_at{position:absolute;right:0;padding-top:10px}.header__2j_at img{opacity:0.5}.header__2j_at img:hover{opacity:1}\n", "",{"version":3,"sources":["header.module.scss"],"names":[],"mappings":"AAAA,eAAQ,iBAAiB,CAAC,OAAO,CAAC,gBAAgB,CAAC,mBAAY,WAAW,CAAC,yBAAkB,SAAS","file":"header.module.scss","sourcesContent":[".header{position:absolute;right:0;padding-top:10px}.header img{opacity:0.5}.header img:hover{opacity:1}\n"]}]);

// Exports
exports.locals = {
	"header": "header__2j_at"
};